import { call, put, takeEvery, all, fork, select } from 'redux-saga/effects';
import * as actionTypes from '../actionTypes/campaign';
import { getHome } from './home';
import { getCartBogoConfig, getQueryParams, getDataCampaign } from '../selectors/campaign';
import apiClient from '../helpers/apiClient';
import config from 'config';

let _client = null;
let xApiClient = 'desktop';
// conditional imports on compilation
'#if CLIENT_TYPE === "mobile"'; // eslint-disable-line
xApiClient = 'mobilesite';
'#endif'; // eslint-disable-line

function structurizeCampaignData(data) {
    const processesData = {};
    data.forEach(item => {
        processesData[item.bannerPosition] = item;
    });
    return processesData;
}

function* getCampaignData({ pageContext, productData, categoryData, cartHasLoyaltyBenefits, loyaltyCount, brand, classification, usePristineData }) {
    const campaignSuccessAction = { type: actionTypes.GET_CAMPAIGN_SUCCESS };
    const campaignErrorAction = { type: actionTypes.GET_CAMPAIGN_FAIL };
    const client = { ..._client };
    try {
        let queryParams = '';
        let price;
        let ftype;
        const cartBogoConfig = yield select(getCartBogoConfig);
        if (pageContext === 'cat') {
            queryParams = `&urlKey=${categoryData.urlKey}&categoryType=${categoryData.categoryType}`;
        } else if (pageContext === 'prod') {
            price = productData.prices.length === 3 ? productData.prices[2].price : productData.prices[1].price;
            const frameType = productData.specifications[1] && productData.specifications[1].items.find(key => {
                if (key.name === 'Frame Type') {
                    return key.value;
                }
                return '';
            });
            ftype = frameType ? frameType.value : '';
            // Campaigns will be filtered based on brand, type, frame type and price
            queryParams = `&brand=${encodeURIComponent(productData.brandName)}&type=${productData.type}&ftype=${ftype}&price=${price}`;
        } else if (pageContext === 'checkout') {
            if (cartHasLoyaltyBenefits === undefined) {
                queryParams = yield select(getQueryParams);
            } else {
                queryParams = `&hasLoyalty=${cartHasLoyaltyBenefits}&loyaltyCount=${loyaltyCount}&brand=${brand}&type=${classification}`;
            }
        }
        let campaignData;
        let isCollectionType;
        if (xApiClient === 'mobilesite') {
            if (pageContext.includes('_col')) {
                const keyArr = pageContext.split('_');
                isCollectionType = true;
                pageContext = keyArr[0];
            }
            campaignData = yield call(async () => client.get(`${config.apiPath.apiCampaign}&pageContext=${pageContext}`));
            campaignData = campaignData.result;
        } else {
            if (pageContext.indexOf('premium-') > -1 || pageContext.indexOf('promo-') > -1) {
                campaignData = {};
            } else {
                campaignData = yield call(async () => client.get(`${config.apiPath.apiCampaign}&pageContext=${pageContext}${queryParams}${cartBogoConfig ? '' : '&bogoConfigRequired=true'}`));
                campaignData = campaignData.result;
            }
            if (['home', 'eyeglasses', 'sunglasses', 'premium-eyeglasses', 'premium-sunglasses'].includes(pageContext) || pageContext.indexOf('promo-') > -1) {
                yield fork(getHome, { campaignData, usePristineData, pageContext });
            } else {
                campaignData.activeAndValidData = structurizeCampaignData(campaignData.activeAndValidData);
            }
            if (campaignData.cart && campaignData.cart.activeCartCampaigns && campaignData.cart.activeCartCampaigns.length) {
                campaignData.cart.activeCartCampaigns = structurizeCampaignData(campaignData.cart.activeCartCampaigns);
            }
        }
        if (xApiClient === 'mobilesite') {
            let campaignDataState = yield select(getDataCampaign);
            if (!campaignDataState) {
                campaignDataState = {};
            }
            if (isCollectionType) {
                if (!campaignDataState.col) {
                    campaignDataState.col = {};
                }
                campaignDataState.col = Object.assign({}, campaignDataState.col);
                campaignDataState.col[pageContext] = campaignData;
            } else {
                campaignDataState[pageContext] = campaignData;
            }
            campaignSuccessAction.data = campaignDataState;
        } else {
            campaignSuccessAction.data = campaignData;
        }
        yield put(campaignSuccessAction);
    } catch (er) {
        if (xApiClient !== 'mobilesite') {
            if (['home', 'eyeglasses', 'sunglasses', 'premium-eyeglasses', 'premium-sunglasses'].includes(pageContext) || pageContext.indexOf('promo-') > -1) {
                yield fork(getHome, { campaignData: {}, usePristineData, pageContext });
            }
        }
        campaignErrorAction.error = er;
        yield put(campaignErrorAction);
    }
}

export function* getCampaign({ pageContext, productData, categoryData }) {
    yield call(getCampaignData, { pageContext, productData, categoryData });
}

export function* runCampaignCalls(client) {
    _client = client ? Object.assign({}, client) : apiClient();
    yield all([
        takeEvery(actionTypes.GET_CAMPAIGN_DATA, getCampaignData)
    ]);
}
